import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import defaults from '../../../translations/en.json';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    backgroundColor: '#d32f2f',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#b71c1c',
    },
  },
}));

type DeleteVisitButtonsProps = {
  setClosed: () => void;
  onDelete: () => void;
  disabled?: boolean;
};

export const DeleteVisitButtons = ({
  setClosed,
  onDelete,
  disabled,
}: DeleteVisitButtonsProps) => {
  const classes = useStyles();

  const handleClick = () => {
    setClosed && setClosed();
  };

  return (
    <div className={classes.buttonContainer}>
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={disabled}
        className={classes.deleteButton}
        onClick={onDelete}
      >
        {defaults.deleteVisit}
      </Button>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {defaults.cancel}
      </Button>
    </div>
  );
};
